import React from 'react'
import {connect} from "react-redux";

//components
import PublicTopNav from '../nav/PublicTopNav'

import CornerCover from "../svgassets/cornerCover";
import AlertFeed from "../alerts/alertFeed";
import PacefiFullScreenSpinner from "../loaders/pacefiFullScreenSpinner";


class PublicWrapper extends React.Component {

    static defaultProps = {
        showNav: true,
    };

    render() {
        return (
            <div className={'page-wrapper'}>
                {this.props.showNav && <PublicTopNav/>}
                <CornerCover
                    style={this.props.cornerCoverStyle || {}}
                />
                <div className={'page-content-wrapper'}>
                    {this.props.children}
                </div>
                <div id="admin-wrapper-alert-feed">
                    <AlertFeed/>
                </div>
                <PacefiFullScreenSpinner/>
            </div>
        )
    }
}



export default connect()(PublicWrapper)
